module.exports = __webpack_public_path__ + "static/OrbitalLow-eb92f4fdec37a55ab8465449144d4174.jpg";